export const APP_TITLE = 'BackOffice';

// Refine names browser tabs "<Page> | Refine" (or just "Refine"). Swap its
// name for ours and keep the page part.
export const backOfficeDocumentTitle = (autoGeneratedTitle: string): string => {
  if (autoGeneratedTitle === 'Refine') return APP_TITLE;
  return autoGeneratedTitle.replace(/ \| Refine$/, ` | ${APP_TITLE}`);
};
